import ENDPOINTS from '../../../const/endpoints';
export var authorizedUsersGetCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return ["get-".concat(ENDPOINTS.authorizedUsers), { accountId: accountId, accountIdType: accountIdType }];
};
